var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentMethod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 80.306,
    viewBox: "0 0 100 80.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.428,
    y1: 0.343,
    x2: 0.748,
    y2: 1.041,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#b0e995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#87e4bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#6ee1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e0db"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.604,
    y1: 2.233,
    x2: 0.404,
    y2: -1.104,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#9ad57d",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#51b482",
    stopOpacity: 0.604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#239f85",
    stopOpacity: 0.867
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119786"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.02,
    y1: 0.02,
    x2: 1.028,
    y2: 1.028,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 0.398,
    x2: 0.5,
    y2: 1.398,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.265,
    y1: 0.009,
    x2: 0.578,
    y2: 0.662,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.429,
    y1: -0.286,
    x2: 0.596,
    y2: 1.565,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.949,
    y1: 1.513,
    x2: 0.581,
    y2: 0.83,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.358,
    y1: -0.082,
    x2: 0.711,
    y2: 1.362,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#2bb9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#42a0f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.5,
    y1: 0.355,
    x2: 0.5,
    y2: 1.063,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a97f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.418,
    y1: -0.334,
    x2: 0.578,
    y2: 1.291,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.372,
    y1: 0.269,
    x2: 0.621,
    y2: 0.719,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#ff8548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#ff6c54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6359"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.372,
    y1: 0.269,
    x2: 0.621,
    y2: 0.719,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CreditCard",
    transform: "translate(-138 -197.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_152",
    "data-name": "Groupe 152",
    transform: "translate(160.626 197.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_143",
    "data-name": "Trac\\xE9 143",
    d: "M189.249,95.741h-70.34a3.517,3.517,0,0,1-3.517-3.517V53.739a3.517,3.517,0,0,1,3.517-3.517h70.34a3.517,3.517,0,0,1,3.517,3.517V92.224A3.517,3.517,0,0,1,189.249,95.741Z",
    transform: "translate(-115.392 -50.222)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_144",
    "data-name": "Trac\\xE9 144",
    d: "M136.8,85.4v16.938a2.07,2.07,0,0,0,1.658,2.015A7.868,7.868,0,0,1,144.39,110a2.058,2.058,0,0,0,1.985,1.535H196.2A2.058,2.058,0,0,0,198.189,110a7.868,7.868,0,0,1,5.932-5.648,2.071,2.071,0,0,0,1.658-2.015V85.4a2.07,2.07,0,0,0-1.658-2.015,7.868,7.868,0,0,1-5.932-5.648A2.058,2.058,0,0,0,196.2,76.2H146.375a2.058,2.058,0,0,0-1.985,1.535,7.868,7.868,0,0,1-5.932,5.648A2.07,2.07,0,0,0,136.8,85.4Z",
    transform: "translate(-132.602 -71.105)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 11.386,
    cy: 11.386,
    rx: 11.386,
    ry: 11.386,
    transform: "translate(27.301 11.373)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_145",
    "data-name": "Trac\\xE9 145",
    d: "M115.392,224.363v7.856a3.517,3.517,0,0,0,3.517,3.517h70.34a3.517,3.517,0,0,0,3.517-3.517v-7.856Z",
    transform: "translate(-115.392 -190.218)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_153",
    "data-name": "Groupe 153",
    transform: "translate(156.428 203.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_146",
    "data-name": "Trac\\xE9 146",
    d: "M167.84,126.422H97.5a3.517,3.517,0,0,1-3.517-3.517V84.42A3.517,3.517,0,0,1,97.5,80.9h70.34a3.517,3.517,0,0,1,3.517,3.517V122.9A3.517,3.517,0,0,1,167.84,126.422Z",
    transform: "translate(-93.983 -80.903)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_147",
    "data-name": "Trac\\xE9 147",
    d: "M115.392,116.076v16.938a2.07,2.07,0,0,0,1.658,2.015,7.868,7.868,0,0,1,5.932,5.648,2.058,2.058,0,0,0,1.985,1.535H174.8a2.058,2.058,0,0,0,1.985-1.535,7.868,7.868,0,0,1,5.932-5.648,2.07,2.07,0,0,0,1.658-2.015V116.076a2.07,2.07,0,0,0-1.658-2.015,7.868,7.868,0,0,1-5.932-5.648,2.058,2.058,0,0,0-1.985-1.535H124.967a2.058,2.058,0,0,0-1.985,1.535,7.868,7.868,0,0,1-5.932,5.648A2.07,2.07,0,0,0,115.392,116.076Z",
    transform: "translate(-111.194 -101.786)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 11.386,
    cy: 11.386,
    rx: 11.386,
    ry: 11.386,
    transform: "translate(27.301 11.373)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_148",
    "data-name": "Trac\\xE9 148",
    d: "M93.983,255.045V262.9a3.517,3.517,0,0,0,3.517,3.517h70.34a3.517,3.517,0,0,0,3.517-3.517v-7.856Z",
    transform: "translate(-93.983 -220.899)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_154",
    "data-name": "Groupe 154",
    transform: "translate(152.23 209.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_149",
    "data-name": "Trac\\xE9 149",
    d: "M146.431,157.1H76.091a3.517,3.517,0,0,1-3.517-3.517V115.1a3.517,3.517,0,0,1,3.517-3.517h70.34a3.517,3.517,0,0,1,3.517,3.517v38.485a3.517,3.517,0,0,1-3.517,3.517Z",
    transform: "translate(-72.574 -111.584)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_150",
    "data-name": "Trac\\xE9 150",
    d: "M93.983,146.757v16.938a2.07,2.07,0,0,0,1.658,2.014,7.868,7.868,0,0,1,5.932,5.648,2.058,2.058,0,0,0,1.985,1.535h49.829a2.058,2.058,0,0,0,1.985-1.535,7.868,7.868,0,0,1,5.932-5.648,2.071,2.071,0,0,0,1.658-2.014V146.757a2.07,2.07,0,0,0-1.658-2.015,7.868,7.868,0,0,1-5.932-5.648,2.058,2.058,0,0,0-1.985-1.535H103.558a2.058,2.058,0,0,0-1.985,1.535,7.868,7.868,0,0,1-5.932,5.648A2.071,2.071,0,0,0,93.983,146.757Z",
    transform: "translate(-89.785 -132.467)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 11.386,
    cy: 11.386,
    rx: 11.386,
    ry: 11.386,
    transform: "translate(27.301 11.373)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_151",
    "data-name": "Trac\\xE9 151",
    d: "M72.574,285.726v7.856a3.517,3.517,0,0,0,3.517,3.517h70.34a3.517,3.517,0,0,0,3.517-3.517v-7.856Z",
    transform: "translate(-72.574 -251.58)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_152",
    "data-name": "Trac\\xE9 152",
    d: "M76.091,226.555h70.34a3.517,3.517,0,0,0,3.517-3.517v-2.5h.681a3.517,3.517,0,0,0,3.517-3.517v-1.509l-15.689-15.689a6,6,0,0,0-4.592-1.848H72.574v25.062a3.517,3.517,0,0,0,3.517,3.517Z",
    transform: "translate(79.656 28.621)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_158",
    "data-name": "Groupe 158",
    transform: "translate(138 226.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_153",
    "data-name": "Trac\\xE9 153",
    d: "M75.522,248.506H6.18A6.18,6.18,0,0,1,0,242.326V203.156a6.18,6.18,0,0,1,6.18-6.18H75.522a6.18,6.18,0,0,1,6.18,6.18v39.171A6.179,6.179,0,0,1,75.522,248.506Z",
    transform: "translate(0 -196.976)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_154",
    "data-name": "Trac\\xE9 154",
    d: "M0,399.161v5.706a6.18,6.18,0,0,0,6.18,6.18H75.522a6.18,6.18,0,0,0,6.18-6.18v-5.706Z",
    transform: "translate(0 -359.517)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_155",
    "data-name": "Trac\\xE9 155",
    d: "M0,240.817H81.7v14.474H0Z",
    transform: "translate(0 -232.221)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_157",
    "data-name": "Groupe 157",
    transform: "translate(6.066 33.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_155",
    "data-name": "Groupe 155"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 6.028,
    cy: 6.028,
    rx: 6.028,
    ry: 6.028,
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 6.028,
    cy: 6.028,
    rx: 6.028,
    ry: 6.028,
    transform: "translate(9.049)",
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_156",
    "data-name": "Groupe 156",
    transform: "translate(41.456 0.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_156",
    "data-name": "Trac\\xE9 156",
    d: "M269.345,374.331H243.491a1.13,1.13,0,0,1-1.13-1.13v-1.957a1.13,1.13,0,0,1,1.13-1.13h25.854a1.13,1.13,0,0,1,1.13,1.13V373.2A1.13,1.13,0,0,1,269.345,374.331Z",
    transform: "translate(-242.361 -370.114)",
    fill: "#0469bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_157",
    "data-name": "Trac\\xE9 157",
    d: "M257.232,410.918H243.491a1.13,1.13,0,0,1-1.13-1.13v-1.957a1.13,1.13,0,0,1,1.13-1.13h13.741a1.13,1.13,0,0,1,1.13,1.13v1.957A1.13,1.13,0,0,1,257.232,410.918Z",
    transform: "translate(-242.361 -399.527)",
    fill: "#0469bb"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethod);
export default __webpack_public_path__ + "static/media/paymentMethod.798eefcd.svg";
export { ForwardRef as ReactComponent };